const color = "#f8f8f8";
export const stylesSelect = {
  container: (base: any) => ({
    ...base,
    width: "100%",
    margin: "0.5em 0",
    boxSizing: "border-box",
  }),
  control: (base: any, state: any) => ({
    ...base,
    backgroundColor: color,
    borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    "&:hover": {
      borderColor: state.isFocused ? "#a2a2a2" : "#a2a2a2",
      boxShadow: state.isFocused ? "#a2a2a2" : "#a2a2a2",
    },
    height: "2em",
    minHeight: 0,
    borderRadius: "0.5em",
    paddingLeft: "1em",
  }),
  valueContainer: (_base: any) => ({
    alignSelf: "baseline",
  }),
  indicatorSeparator: (base: any) => ({
    ...base,
    display: "none",
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "hsl(0, 0%, 50%)",
    fontFamily: "Poppins Regular",
    fontSize: "0.9em",
  }),
  dropdownIndicator: (_base: any) => ({
    padding: "0 8px",
  }),
};
